import { useContext } from "react";
import { SessionContext } from "../SessionContext";
import { useNavigate } from "react-router-dom";

const Logout = () => {

    const [isLoggedIn, setIsLoggedIn] = useContext(SessionContext);
    let navigate = useNavigate();

    localStorage.setItem('user_code', '');
    localStorage.removeItem('user_code');
    setIsLoggedIn(false);

    navigate("/log", { replace: true });

}

export default Logout;